<template>
  <div class="mb-1">
    <!--begin:: Google Map Section-->
    <div class="map-section" v-if="!mapHistoryLoading">
      <!--begin:: Google Map Area-->
      <gmap-map
        ref="mainMap"
        :center="startLocation"
        :zoom="6"
        map-type-id="roadmap"
        style="width: 100%; height: 100%"
        :options="{
          zoomControl: true,
          scaleControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          disableDefaultUi: false,
        }"
      >
        <gmap-marker
          v-for="(item, key) in coordinates"
          :key="key"
          :position="getPosition(item)"
          :clickable="true"
          :icon="icon"
          @click="toggleInfo(item, key)"
        ></gmap-marker>
      </gmap-map>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <loading-box></loading-box>
      </div>
      <!--end:: Google Map Area-->

      <!--begin:: Map Location Detail Area-->
      <transition name="map-info-window-slide">
        <div
          class="map-info-window"
          :opened="infoOpened"
          :position="infoPosition"
          v-if="infoOpened"
        >
          <div class="city-info" v-if="selectedMarker">
            <div class="city-location">{{ selectedMarker.full_name }}</div>
            <div class="map-btn-close-holder">
              <button
                class="btn btn-danger map-btn-close"
                @click="closeInfoWindow()"
              >
                {{ $t("dashboard.close") }}
              </button>
            </div>
          </div>
        </div>
      </transition>
      <!--end:: Map Location Detail Area-->
    </div>
    <!--end:: Google Map Section-->
  </div>
</template>
  
<script>
import LoadingBox from "@/assets/components/loader/LoadingBox";
import baseModule, {
  ERROR,
  MODULE_NAME,
  SUCCESS,
  BRANCHES_DATA,
  GET_BRANCHES_DATA,
  GET_BRANCHES_DATA_LOADING,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";
const _MODULE_NAME = MODULE_NAME;
export default {
  name: "DashboardUsersMap",
  props: ["historyData"],
  components: {
    LoadingBox,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  computed: {
    historiesData() {
      this.data = [];
      this.data = store.getters[_MODULE_NAME + "/" + GET_BRANCHES_DATA];
      if (!data) return 0;
      return data;
    },
    mapHistoryLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_BRANCHES_DATA_LOADING];
    },
  },
  data: function () {
    return {
      startLocation: {
        lat: 39.5708783,
        lng: 35.6807645,
      },
      data: null,
      icon: null,
      iconList: [
        {
          url: "http://masima.limonist.ist/public/assets/images/black.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/danger.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/marker.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/success.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/warning.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
      ],
      coordinates: [],
      selectedKey: null,
      selectedMarker: null,
      infoOpened: false,
    };
  },
  watch: {
    historyData: function () {
      this.coordinates = [];
      this.filterResults();

      let randomIcon = this.iconList[_.random(1, 4)];
      this.icon = randomIcon;
    },
  },
  mounted() {
    this.filterResults();
    this.icon = this.iconList[_.random(1, 4)];
  },
  methods: {
    getMarkers(key) {
      if (this.selectedKey === key) return this.mapMarkerActive;
      return this.mapMarker;
    },
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng),
      };
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.selectedMarker = marker;
      this.selectedKey = key;
      this.infoOpened = !this.infoOpened;
    },
    closeInfoWindow: function () {
      this.infoOpened = false;
      this.markerOptions = this.mapMarker;
    },
    async filterResults() {
      if(this.historyData){
        await this.$store.dispatch(_MODULE_NAME + "/" + GET_BRANCHES_DATA, {
        filters: {
          institution_id: this.historyData.institution_id,
          month_id: this.historyData.month_id,
          year_id: this.historyData.year_id,
        },
      });
      }else{
        await this.$store.dispatch(_MODULE_NAME + "/" + GET_BRANCHES_DATA, {})
      }
      
      this.data = [];
      this.data = store.getters[_MODULE_NAME + "/" + BRANCHES_DATA];

      if (!this.data) return 0;
      this.data.forEach((item) => {
        this.coordinates.push({
          full_name: item.name,
          lat: item.latitude,
          lng: item.longitude,
        });
      });
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map-section {
  height: 500px;
  position: relative;
  overflow: hidden;
}

.map-info-window {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
}

.map-info-window-slide-leave-active,
.map-info-window-slide-enter-active {
  transition: 0.5s;
}

.map-info-window-slide-enter {
  transform: translate(0, -100%);
}

.map-info-window-slide-leave-to {
  transform: translate(0, -100%);
}

.city-info > div {
  margin-bottom: 10px;
}

.map-btn-close-holder {
  margin-top: 10px;
}
</style>
  